import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {UrlConstant} from "@shared/constants/url.constant";

@Injectable({
  providedIn: 'root'
})
export class UploadFileService extends BaseService{
  readonly prefixPrivateUrl =  UrlConstant.PRIVATE_FILES.PREFIX;
  readonly prefixPublicUrl =  UrlConstant.PUBLIC_FILES.PREFIX;

  uploadEditorFile(formData: any) {
    return this.post(this.prefixPrivateUrl + UrlConstant.PRIVATE_FILES.UPLOAD_TINYMCE, formData);
  }
}
